import ReadOnlyField from './ReadOnlyField';
import { IReadOnlyField } from './ReadOnly.interfaces';

export default ReadOnlyField;
export { ReadOnlyField, IReadOnlyField };
